import { initEmblaSlider } from '../utils/emblaSlider';

export default (node) => {
  if (!node) {
    console.warn('ProductImages requires a valid DOM node');
    return;
  }

  const productId = node.dataset.productId;

  const pagination = node.querySelector('[data-pagination]');
  const desktopPagination = node.querySelector('[data-desktop-pagination]');
  const media = node.querySelectorAll('[data-media]');
  const featuredImageContainer = node.querySelector(
    '[data-featured-image-container]'
  );
  const featuredImages = Array.from(
    featuredImageContainer?.querySelectorAll('img') || []
  );
  let emblaApi = null;
  let activeIndex = -1;
  let resizeTimeout = null;

  let variantImages = {};
  try {
    variantImages = JSON.parse(node.dataset.variantImages || '{}');
  } catch (error) {
    console.warn('Failed to parse variant images:', error);
  }

  const initSlider = () => {
    emblaApi = initEmblaSlider(node, {});
  };

  const initDesktopPagination = () => {
    if (!desktopPagination) return;

    const bullets = desktopPagination.querySelectorAll('[data-bullet]');

    // Create Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Array.from(media).indexOf(entry.target);
          if (index !== -1 && entry.isIntersecting) {
            // Only update if we have a new active index
            if (activeIndex !== index) {
              // Remove active class from previous bullet
              if (activeIndex !== -1) {
                bullets[activeIndex]?.classList.remove('opacity-100');
                bullets[activeIndex]?.classList.add('opacity-40');
              }
              // Add active class to new bullet
              bullets[index]?.classList.add('opacity-100');
              bullets[index]?.classList.remove('opacity-40');
              activeIndex = index;
            }
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    // Observe all media elements
    media.forEach((item) => {
      observer.observe(item);
    });

    bullets.forEach((bullet, index) => {
      bullet.addEventListener('click', () => {
        media[index]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    });
  };

  const handleResize = () => {
    // Debounce resize handler
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(() => {
      const isMobile = window.innerWidth < 768;

      if (isMobile && !emblaApi) {
        initSlider();
      } else if (!isMobile && emblaApi) {
        emblaApi.destroy();
        emblaApi = null;
      }
    }, 150);
  };

  const handleVariantChange = (event) => {
    if (event.detail?.productId !== productId) return;

    const variantId = event.detail?.variant?.id;
    const variantImage = featuredImages.find(
      (image) => image.dataset.attachedVariant === variantId
    );

    // Hide all featured images first
    featuredImages.forEach((image) => {
      image.classList.add('hidden');
    });

    // Show only the selected variant image
    if (variantImage) {
      variantImage.classList.remove('hidden');
    }
  };

  // Initialize component
  initDesktopPagination();
  window.addEventListener('resize', handleResize);
  handleResize();

  document.addEventListener('variant:change', handleVariantChange);
};
